import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"trade_simple",
    list_id:"trade_simple_frame_list",
    x_column_list_arr:[
      {"key":"a_date","name":"거래일","width":"110","is_show":"1"},
      {"key":"a_subject_detail","name":"구분","width":"90","is_show":"1"},
      {"key":"a_memo","name":"적요","width":"200","is_show":"1"},
      {"key":"row_view_debt_in","name":"청구","width":"100","is_show":"1"},
      {"key":"row_view_money_in","name":"입금","width":"100","is_show":"1"},
      // {"key":"row_view_money_out","name":"출금","width":"100","is_show":"1"},
      // {"key":"row_view_debt_out","name":"줄돈","width":"100","is_show":"1"},
      {"key":"row_view_remain_total","name":"미수금","width":"100","is_show":"1"},
      {"key":"a_cust_name","name":"거래처","width":"130","is_show":"1"},
      {"key":"writer_name","name":"작성자","width":"110","is_show":"1"},
      // {"key":"a_create_date","name":"작성일","width":"160","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':20,
      'order_id':'a_create_date DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_ymd","a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;